module.exports = __webpack_public_path__ + "static/media/kaneda.fdcb1c84.png";